export const API_PATH_ApiAlertMgtmUserInfoGet = '/services/alert-mgtm/apiAlertMgtmUserInfoGet';
